export default {
  getFarm: (state) => state.farm,
};
